export default "__VITE_ASSET__BQoA3Pq___"